import React from 'react';
import Autocomplete from 'react-autocomplete';
import Modal from '../../components/Modal';

const Formulario = props => (
  <Modal title={props.title} idModal='mantenimiento' isOpen={props.isOpen} closeModal={props.closeModal} modalSize='modal-dialog modal-lg'>
    <div className='form-group'>
      <div className='row'>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='desUbiPed'>Descripción de la ubicación del pedido</label>
          <input className='form-control' id='desUbiPed' onChange={props.onChangeValue} name='desUbiPed' type='text' value={props.desUbiPed} />
        </div>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='sucursal'>Sucursal</label>
          <div className='select'>
            <select className='form-control' id='sucursal' onChange={props.onChangeValue} name='sucursal' value={props.sucursal} >
              <option disabled value=''>Selecciona una sucursal</option>
              {
                props.sucursales.map(sucursal => (
                  <option
                    key={sucursal.codSucursal}
                    value={sucursal.codSucursal}
                  >
                    {sucursal.nomSucursal}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
      </div>
    </div>
    <div className='form-group'>
      <div className='row'>
        <div className='col-md-4'>
          <div className='checkbox'>
            <label htmlFor='indCarrocero'>
              <input type='checkbox' id='indCarrocero' name='indCarrocero' checked={props.indCarrocero} onChange={props.onCheck} />
              <div className='checkbox-skin' />
              Indicador de carrocero
            </label>
          </div>
        </div>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='sucursal'>Filial</label>
          <div className='select'>
            <select className='form-control' id='filial' onChange={props.onChangeValue} name='filial' value={props.filial} >
              <option disabled value=''>Selecciona una filial</option>
              {
                props.filiales.map(filial => (
                  <option
                    key={filial.id}
                    value={filial.id}
                  >
                    {filial.nombre}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>


      </div>
    </div>
    <div className='form-group'>
      <div className='row'>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='provCarroceroName'>Proveedor de carrocero</label>
          <Autocomplete
            inputProps={{
              className: 'form-control',
              placeholder: 'Ingrese un nombre',
              name: 'provCarroceroName',
            }}
            wrapperStyle={{
              display: 'inline-block',
              position: 'relative',
              zIndex: '10',
            }}
            menuStyle={{
              position: 'absolute',
              left: '0',
              top: '100%',
              maxHeight: '350px',
              overflow: 'auto',
              border: '1px solid #cccccc',
            }}
            name='provCarroceroName'
            items={
              props.listaProvCarrocero
                .filter(({ nomPerso }) => nomPerso.toLowerCase()
                                            .indexOf(props.provCarroceroName.toLowerCase())>=0)
            }
            getItemValue={item => item.codPerso}
            renderItem={(item, isHighlighted) =>
              <div key={item.codPerso} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                {item.nomPerso}
              </div>
            }
            onChange={props.onChangeValue}
            onSelect={key => props.selectProv(key)}
            value={props.provCarroceroName}
          />
        </div>
      </div>
    </div>
    <div className='form-group'>
      <div className='row'>
        <div className='col-md-4'>
          <div className='checkbox'>
            <label htmlFor='indInventario'>
              <input type='checkbox' id='indInventario' name='indInventario' checked={props.indInventario} onChange={props.onCheck} />
              <div className='checkbox-skin' />
              Indicador de inventario
            </label>
          </div>
        </div>
      </div>
    </div>
    {
      props.disabled ?
        <div className='form-group'>
          <div className='row'>
            <div className='col-md-4'>
              <div className='checkbox'>
                <label htmlFor='indInactivo'>
                  <input type='checkbox' id='indInactivo' name='indInactivo' checked={props.indInactivo} onChange={props.onCheck} />
                  <div className='checkbox-skin' />
                  Activo
                </label>
              </div>
            </div>
          </div>
        </div> : null
    }
    <div className='modal-actions'>
      <button className='btn btn-return' onClick={() => props.closeModal()}>Cancelar</button>
      { !props.disabled ?
        <button className='btn btn-primary pull-right' onClick={() => props.create()}>Guardar</button> :
        <button className='btn btn-primary pull-right' onClick={() => props.edit(props.registroSelected)}>Guardar</button>
      }
    </div>
  </Modal>
);

Formulario.defaultProps = {
  isOpen: false,
};

export default Formulario;



// WEBPACK FOOTER //
// ./src/pages/MantUbicacionPedido/Formulario.js